export const PREMIUM_SUBSCRIPTION_VALUE = 297;
export const PREMIUM_CASHBACK_VALUE = 29.7;

export const PREMIUM_COMMISSION_LEVELS = [
  { level: 1, label: "Indicação direta", value: 100 },
  { level: 2, label: "2º nível", value: 20.98 },
  { level: 3, label: "3º nível", value: 15.74 },
  { level: 4, label: "4º nível", value: 10.49 },
  { level: 5, label: "5º nível", value: 5.25 },
] as const;

export const PREMIUM_BENEFITS = [
  "Comissões em até 5 níveis quando associados da rede aderirem ao premium",
  "Acesso ao plano de carreira da BRPoints",
  "Ganhe 10% de cashback Direto no app BRPoints",
  "Ganhos recorrentes de toda operação financeira da sua equipe",
];

export function formatPremiumCurrency(value: number): string {
  return Number(value || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
